import Paths from "../../paths";
import Pages from "../../pages";
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import { Redirect } from "react-router-dom";
import { updateSignupPage } from "../../actions";
import { useSelector, useDispatch } from "react-redux";

const Redirector = ({ page, this_page, intl, enable_firebase_authentication }) => {
  const redirect = page === this_page ? false : true;
  const territoryFirebaseEnabled = useSelector((state) => state.territory.enable_firebase_authentication);
  const firebaseEnabled = enable_firebase_authentication ?? territoryFirebaseEnabled;

  function redirect_path() {
    switch (page) {
      // new paths
      case Pages.CONCLUSION_PAGE:
        return Paths.CONCLUSION_PATH;
      case Pages.CONTACT_PAGE:
        return Paths.CONTACT_PATH;
      case Pages.CULTURAL_BACKGROUND_PAGE:
        return Paths.CULTURAL_BACKGROUND_PATH;
      case Pages.HEALTH_AND_MEDICAL_PAGE:
        return Paths.HEALTH_AND_MEDICAL_PATH;
      case Pages.DIET_PAGE:
        return Paths.DIET_PATH;
      case Pages.GUEST_PACKAGES_PAGE:
        return Paths.GUEST_PACKAGES_PATH;
      case Pages.FAMILY_INTERESTS_PAGE:
        return Paths.FAMILY_INTERESTS_PATH;
      case Pages.REFERENCES_PAGE:
        return Paths.REFERENCES_PATH;
      case Pages.GUEST_PREFERENCES_PAGE:
        return Paths.GUEST_PREFERENCES_PATH;
      case Pages.GUEST_INTERACTION_LEVEL_PAGE:
        return Paths.GUEST_INTERACTION_LEVEL_PATH;
      case Pages.HOLDING_PAGE:
        return Paths.HOLDING_PATH;
      case Pages.HOUSE_PAGE:
        return Paths.HOUSE_PATH;
      case Pages.HOUSE_CONTINUED_PAGE:
        return Paths.HOUSE_CONTINUED_PATH;
      case Pages.INFO_PAGE:
        return Paths.INFO_PATH;
      case Pages.INTERVAL_PAGE:
        return Paths.INTERVAL_PATH;
      case Pages.PAYMENTS_PAGE:
        return Paths.PAYMENTS_PATH;
      case Pages.PETS_PAGE:
        return Paths.PETS_PATH;
      case Pages.PHOTO_PAGE:
        return Paths.PHOTO_PATH;
      case Pages.PROFILE_PAGE:
        return Paths.PROFILE_PATH;
      case Pages.REGISTER_PAGE:
        return firebaseEnabled ? Paths.FIREBASE_REGISTER_PATH : Paths.REGISTER_PATH;
      case Pages.RESIDENTS_PAGE:
        return Paths.RESIDENTS_PATH;
      case Pages.ROOMS_PAGE:
        return Paths.ROOMS_PATH;
      case Pages.SMOKING_PAGE:
        return Paths.SMOKING_PATH;
      case Pages.WITHDRAW_PAGE:
        return Paths.WITHDRAW_PATH;
      case Pages.REFERRAL_PAGE:
        return Paths.REFERRAL_PATH;
      case Pages.PHONE_VERIFICATION_PAGE:
        return Paths.PHONE_VERIFICATION_PATH;
      case Pages.FIREBASE_DETAILS_PAGE:
        return Paths.FIREBASE_DETAILS_PATH;
      default:
        return firebaseEnabled ? Paths.FIREBASE_REGISTER_PATH : Paths.REGISTER_PATH;
    }
  }

  const dispatch = useDispatch();
  const redirectPath = redirect_path();

  useEffect(() => {
    if (redirect && redirectPath) {
      setTimeout(() => dispatch(updateSignupPage(page)), 0);
    }
  }, [redirect, redirectPath, page, dispatch]);

  if (redirect && redirectPath) {
    return <Redirect to={redirectPath} />;
  }

  return null;
};

Redirector.propTypes = {
  page: PropTypes.string,
  this_page: PropTypes.string,
  intl: PropTypes.object,
};

export default injectIntl(Redirector);
